var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hb-basic-page',{attrs:{"loading":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }